/** CRM: keep weight ≈ input; scale wt/mm with thickness reduction. */
export function calculateCrm(input: {
  weight: number;
  thickness: number;
  targetThickness: number;
  width: number | null;
  wt_per_m: number | null;
}): {
  weight: number;
  thickness: number;
  width: number | null;
  wt_per_m: number;
} {
  const start = Math.max(input.thickness, 0.001);
  const target = Math.max(input.targetThickness, 0.001);
  const ratio = target / start;
  const wtPerM =
    input.wt_per_m && input.wt_per_m > 0
      ? input.wt_per_m * ratio
      : input.width && input.width > 0
        ? ((input.weight * 1000) / input.width) * ratio
        : 0;
  return {
    weight: input.weight,
    thickness: target,
    width: input.width,
    wt_per_m: wtPerM,
  };
}

export function calculateSkinPass(
  weight: number,
  factor = 0.999,
): { weight: number } {
  return { weight: weight * factor };
}

export function calculateAnnealing(weight: number): { weight: number } {
  return { weight };
}
